import React, { FC, useRef, useState } from 'react';
import _ from 'lodash';
import { addComma } from 'src/utils/common';
import { dateFormat } from 'src/utils/dateSet';
import IconButton from 'src/components/atoms/buttons/IconButton';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import CheckBox from 'src/components/atoms/CheckBox';

export const gridOption = (data: any, totalCount: number, bindStateData: any) => {
  const gridData = _.cloneDeep(data) || [];
  const disableEvent = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const gridFnc = {
    viewContent: (param: any) => {
      const downloadEvt = (e: any) => {};
      const deleteEvt = (e: any) => {};
      return (
        <div className="_custom_div_right" style={{ width: '100px' }}>
          <div className="_r_btn">
            <IconButton
              icon="ri-download-2-line"
              clickEvent={downloadEvt}
              type="type3"
              styleDef={{
                width: '28px',
                height: '28px',
                fontSize: '16px',
              }}
            />
          </div>
          <div className="_r_btn">
            <IconButton
              icon="ri-delete-bin-2-line"
              clickEvent={deleteEvt}
              type="type3"
              styleDef={{
                width: '28px',
                height: '28px',
                fontSize: '16px',
              }}
            />
          </div>

          {/* <DefaultButton
            text="확인"
            clickEvent={e => viewModal(e)}
            icon=""
            type="type1"
            styleDef={{ height: '28px', fontSize: '13px', width: '90px' }}
          /> */}
        </div>
      );
    },
    createDate: (param: any) => {
      return dateFormat(param[0], 'YYYY.MM.DD HH:mm');
    },
    viewCount: (param: any) => {
      const count = param[0] || 0;
      return addComma(count);
    },
  };

  // gridData
  const gridOption = {
    label: [
      {
        label: '',
        col: 'id',
        width: '0px',
        align: 'left',
        useYN: 'none',
      },
      {
        label: '순번',
        col: 'num',
        width: '50px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
      },
      {
        label: '문서종류',
        col: 'docType',
        width: '100px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
      },
      {
        label: '파일명',
        col: 'fileName',
        width: 'calc(100% - 350px)',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
      },
      {
        label: '대상자',
        col: 'recipient',
        width: '100px',
        align: 'center',
        sort: { use: false, active: true, status: 'desc' },
      },
      {
        label: '',
        col: '',
        width: '100px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewContent, param: [] },
      },
    ],
    styleDef: { width: '100%', fontSize: '13px' },
    data: gridData,
    totalCount: totalCount,
  };

  return gridOption;
};
